.slideshow {
  --pgm-mosaic-width: 80px;
  border-bottom: 4px solid var(--pgm-sys-color-surface-container-high);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding-bottom: var(--pgm-sys-spacing-10);
  position: relative;
}

.mosaicLeft,
.mosaicRight {
  display: block;
  height: 100%;
  opacity: 0.08;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: var(--pgm-mosaic-width);
}

.mosaicLeft::before,
.mosaicLeft::after,
.mosaicRight::before,
.mosaicRight::after {
  content: "";
  left: 0;
  position: absolute;
  width: 100%;
}

.mosaicLeft {
  background: linear-gradient(
    to bottom,
    transparent 0 calc(var(--pgm-mosaic-width) * 2.675),
    var(--pgm-sys-color-brand-secondary) calc(var(--pgm-mosaic-width) * 2.675)
  );
  left: 0;
}

.mosaicLeft::before {
  background-color: var(--pgm-sys-color-brand-primary);
  clip-path: polygon(0% 0%, 0% 100%, 98.75% 0%);
  height: calc(var(--pgm-mosaic-width) * 2.4875);
  top: 0;
}

.mosaicLeft::after {
  background-color: var(--pgm-sys-color-brand-tertiary);
  clip-path: polygon(13.75% 100%, 100% 0%, 100% 100%);
  height: calc(var(--pgm-mosaic-width) * 2.2);
  top: calc(var(--pgm-mosaic-width) * 0.3375);
}

.mosaicRight {
  background: linear-gradient(
    to top,
    transparent 0 calc(var(--pgm-mosaic-width) * 2.675),
    var(--pgm-sys-color-brand-secondary) calc(var(--pgm-mosaic-width) * 2.675)
  );
  right: 0;
}

.mosaicRight::before {
  background-color: var(--pgm-sys-color-brand-primary);
  bottom: 0;
  clip-path: polygon(100% 100%, 100% 0%, 1.25% 100%);
  height: calc(var(--pgm-mosaic-width) * 2.4875);
}

.mosaicRight::after {
  background-color: var(--pgm-sys-color-brand-tertiary);
  bottom: calc(var(--pgm-mosaic-width) * 0.3375);
  clip-path: polygon(86.25% 0%, 0% 100%, 0% 0%);
  height: calc(var(--pgm-mosaic-width) * 2.2);
}


.container {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: var(--pgm-sys-spacing-10);
  justify-content: center;
  max-width: 1800px;
  padding: var(--pgm-sys-spacing-6);
  width: 100%;
}

.control {
  flex-shrink: 0;
}

.viewport {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.track {
  display: flex;
  transition: transform 400ms cubic-bezier(0.2, 0, 0, 1);
  will-change: transform;
}

.slide {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 100%;
  gap: var(--pgm-sys-spacing-10);
  justify-content: center;
  min-width: 0;
}

.infos {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-10);
  justify-content: center;
  min-width: 0;
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  white-space: pre-line;
}

.description {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
  white-space: pre-line;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
}

.image {
  border-radius: 24px;
  flex: 0 0 600px;
  height: 464px;
  object-fit: cover;
  width: 600px;
}

.steps {
  contain: layout;
  display: flex;
  gap: var(--pgm-sys-spacing-2);
}

.step,
.stepActive {
  background-color: var(--pgm-sys-color-surface-dim);
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  height: 16px;
  padding: 0;
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1),
    background-color 300ms cubic-bezier(0.2, 0, 0, 1);
  width: 16px;
}

.stepActive {
  background-color: var(--pgm-sys-color-tertiary);
  width: 40px;
}

.step:focus-visible,
.stepActive:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 4px;
}

@media (max-width: 1280px) {
  .image {
    flex: 1 1 0;
    height: auto;
    max-width: 600px;
    width: auto;
  }
}

@media (max-width: 1024px) {
  .slide {
    flex-direction: column;
  }

  .image {
    max-width: 100%;
  }
}

@media (max-width: 599.98px) {
  .slideshow {
    --pgm-mosaic-width: 48px;
  }

  .container {
    gap: var(--pgm-sys-spacing-2);
    padding: var(--pgm-sys-spacing-4);
  }

  .infos {
    gap: var(--pgm-sys-spacing-6);
  }

  .image {
    display: none;
  }

  .slide {
    gap: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .step,
  .stepActive,
  .track {
    transition: none;
  }
}
